import { useState } from "react";

export function useAlertDialog() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [urlToOpen, setUrlToOpen] = useState<string | null>(null);

  const handleOpenDialog = (url: string) => {
    setUrlToOpen(url);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleAgreeDialog = () => {
    if (urlToOpen) {
      window.open(urlToOpen, "_blank");
    }
    setDialogOpen(false);
  };

  return {
    dialogOpen,
    handleOpenDialog,
    handleCloseDialog,
    handleAgreeDialog,
  };
}
